const activitypackage = {
  getlist: 'activitypackage/getlist',
  add: 'activitypackage/add',
  update: 'activitypackage/update',
  remove: 'activitypackage/remove',
  get: 'activitypackage/get-by-admin',
  getall: 'activitypackage/getall',
}
export default activitypackage
